import { auth } from '../../../system/api'
import { router } from '../../../system/routing'
import { isEmpty } from 'lodash'

export default (payload, next) => {
    const locationQuery = router.getLocationQuery()
    const storageAuthToken = auth.getToken()
    const authToken = locationQuery.auth_token || storageAuthToken

    if (!authToken || !locationQuery.package_id || !locationQuery.package_code) {
        return router.replace('/403')
    }

    auth.setToken(authToken)

    return next(payload)
}
